import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";

@Component({
	selector: "caass-ms-todays-visitees",
	templateUrl: "./ms-todays-visitees.component.html",
	styleUrls: ["./ms-todays-visitees.component.css"],
})
export class MsTodaysVisiteesComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	@Input() FacilityID: number = -1;

	Inited: boolean = false;

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: boolean = false;

	//Main
	SelectedVisitee: any;
	lstVisitee: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "VisiteeName", header: "Destination" },
		{ field: "Email", header: "Email" },
		{ field: "VisiteeCount", header: "# of visitors" },
	];

	OptionID: number = 0;
	Title: string = "Facility";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.FacilityID == undefined || this.FacilityID < 0) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.TodaysVisiteesSelectList(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.lstVisitee = response;

				if (this.Inited == false) {
					this.Inited = true;
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedVisitee = val.data;
	}
	onRowUnselect(val) {
		this.SelectedVisitee = null;
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ClearData() {
		this.lstVisitee = [];
	}

	//////////////////////////////////////////////////////////
}
